import api from "../../../services/api";
import { GetCommissionsParams, GetCommissionsResponse } from "./types";

export async function getCommissions(params: GetCommissionsParams) {
  const response = await api.get<GetCommissionsResponse>('/panel/commission', { params })

  return response.data
}
